import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteAuditLogRequest,
  getAuditLogs,
} from "../../../services/api/auditLogs/auditLogsApi";

export const fetchAuditLogs = createAsyncThunk(
  "auditLogs/fetchAuditLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getAuditLogs(params);
      const logs = response.data.data;
      return {
        logs: logs.data || [],
        pagination: {
          current_page: logs.current_page || 1,
          last_page: logs.last_page || 1,
          total: logs.total || 0,
          per_page: logs.per_page || 10,
        },
      };
    } catch (error) {
      return rejectWithValue("Failed to fetch audit logs");
    }
  },
);

export const deleteAuditLog = createAsyncThunk(
  "auditLogs/deleteAuditLog",
  async (id, { rejectWithValue }) => {
    try {
      await deleteAuditLogRequest(id);
      return id;
    } catch (error) {
      return rejectWithValue("Failed to delete audit log");
    }
  },
);

const initialState = {
  auditLogs: [],
  currentPage: 1,
  lastPage: 1,
  totalLogs: 0,
  perPage: 10,
  loading: false,
  error: null,
  deleteLoading: false,
  deleteError: null,
};

const auditLogsSlice = createSlice({
  name: "auditLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.auditLogs = action.payload.logs || [];
        state.currentPage = action.payload.pagination.current_page;
        state.lastPage = action.payload.pagination.last_page;
        state.totalLogs = action.payload.pagination.total;
        state.perPage = action.payload.pagination.per_page;
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAuditLog.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
      })
      .addCase(deleteAuditLog.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.auditLogs = state.auditLogs.filter(
          (log) => log.id !== action.payload,
        );
        state.totalLogs = Math.max(0, state.totalLogs - 1);
      })
      .addCase(deleteAuditLog.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
      });
  },
});

export default auditLogsSlice.reducer;
